// extracted by mini-css-extract-plugin
module.exports = {"value":"x5E3zh","pointerContainer":"Dc2g_R","pointer":"RZkOZb","pointerActive":"e1ecQw"};